<template>
  <div class="imageBox" v-if="bool">
    <div class="info">
      <div class="back" @click="goBack">
        <img src="@/assets/images/返回.png" alt="" />
        <div class="backTitle">            {{
              store.state.language == "cn"
                ? '返回'
                : 'Back'
            }}</div>
      </div>

      <img
        class="mainTitle"
        :src="getImagePath(productItem.mainImage)"
        alt=""
      />
      <div class="productType">
        <div class="itemTItle">
          <span class="itemTItleInner">{{
            store.state.language == "cn" ? productItem.name : productItem.nameEn
          }}</span>
        </div>

        <div
          :class="index % 2 != 1 ? 'typeItem' : 'typeItemTwo'"
          v-for="(item, index) in typeItem"
          v-bind:key="item.id"
        >
          <div class="typeTitle" :class="store.state.isPc ? 'Pc' : 'Phone'">
            {{ store.state.language == "cn" ? Dic[item].cn : Dic[item].en }}
          </div>
          <div class="typeInfo" :class="store.state.isPc ? 'Pc' : 'Phone'">
            {{
              store.state.language == "cn"
                ? productItem[item]
                : productItem[`${item}En`]
            }}
          </div>
        </div>

        <div class="buttonImgBox" :class="store.state.isPc ? 'Pc' : ''">
          <div
            class="buttonItem"
            :class="store.state.isPc ? 'Pc' : ''"
            v-if="productItem.image1 != ''"
            @click="openImage(productItem.image1)"
          >
            <img :src="getImagePath(productItem.image1)" alt="" />
          </div>
          <div
            class="buttonItem"
            :class="store.state.isPc ? 'Pc' : ''"
            v-if="productItem.image1 != ''"
            @click="openImage(productItem.image2)"
          >
            <img :src="getImagePath(productItem.image2)" alt="" />
          </div>
          <div
            class="buttonItem"
            :class="store.state.isPc ? 'Pc' : ''"
            v-if="productItem.image1 != ''"
            @click="openImage(productItem.image3)"
          >
            <img :src="getImagePath(productItem.image3)" alt="" />
          </div>
        </div>
      </div>
    </div>

    <ImageOpen ref="ImageOpenBox" />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import images from "@/utils/images.ts";
import products from "@/assets/json/products.json";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import ImageOpen from "@/components/ImageOpen.vue";
const router = useRouter();

var bool = ref(false);
const route = useRoute();
const store = useStore();
var { getImagePath } = images;
var list = ref(products.Configure);
var list2 = ref(products.ProductType);
var Dic = ref(products.ProductNameDic);
var productItem = ref();
const productId = ref();
var typeItem = ref();
const ImageOpenBox = ref();

const goBack = () => {
  router.push({ path: "/" });
};

const getInfo = () => {
  bool.value = false;
  list.value.forEach((element) => {
    if (element.id == route.query.id) {
      productId.value = route.query.id;
      productItem.value = element;
    }
  });
  list2.value.forEach((e) => {
    if (e.id == route.query.id) {
      typeItem.value = e.keyArray;
    }
  });
  bool.value = true;
};

const openImage = (string) => {
  console.log(ImageOpenBox.value.openImage, string);
  // ImageOpenBox.value.openString(openString)
  ImageOpenBox.value?.openString(string)
};

onMounted(() => {
  getInfo();
});
</script>
<!-- getImagePath('软件图片.png') -->
<style lang="scss" scoped>
.imageBox {
  width: 100%;
  min-height: calc(100vh - 12.125rem);

  margin: 0 auto;
  padding-top: 1.5rem;
  min-width: 42.75rem;
  position: relative;

  .info {
    width: 100%;
    max-width: 75rem;
    position: relative;
    margin: 0 auto;
  }

  .mainTitle {
    padding-top: 24px;
    width: 100%;
    max-width: 61.06rem;
    display: block;
    margin: 0 auto;
  }

  .productType {
    box-sizing: border-box;
    padding: 0 1.75rem;

    .itemTItle {
      margin-bottom: 0.94rem;
      .itemTItleInner {
        line-height: 2.25rem;
        background-color: #d93a1d;
        border-radius: 0.5rem;
        font-family: SourceHanSansCN-Bold;
        font-size: 1.5rem;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 700;
        text-align: center;
        padding: 0.28rem 0.83rem;
      }
    }

    .typeItem {
      width: 100%;
      //   height: 2.13rem;
      display: flex;
      font-family: SourceHanSansCN-Regular;
      color: #252525;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 2.13rem;
      align-items: center;
      background: #cccccc;

      .typeTitle {
        padding-left: 0.63rem;
        font-size: 1.13rem;
        &.Pc {
          width: 17.63rem;
        }
        &.Phone {
          width: 12.38rem;
        }
      }

      .typeInfo {
        background: #b3b3b3;
        flex: 1;
        padding-left: 0.63rem;
        font-size: 1.13rem;
      }
    }

    .typeItemTwo {
      width: 100%;
      height: 2.13rem;
      display: flex;
      font-family: SourceHanSansCN-Regular;
      color: #252525;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 2.13rem;

      .typeTitle {
        // background: #cccccc;
        height: auto;
        padding-left: 0.63rem;
        font-size: 1.13rem;
        &.Pc {
          width: 17.63rem;
        }
        &.Phone {
          width: 12.38rem;
        }
      }

      .typeInfo {
        // background: #b3b3b3;
        flex: 1;
        padding-left: 0.63rem;
        font-size: 1.13rem;
      }
    }

    .buttonImgBox {
      width: 100%;
      // box-sizing: border-box;
      height: 9.25rem;
      padding-top: 2.5rem;
      padding-bottom: 2.31rem;
      display: flex;
      justify-content: space-between;
      &.Pc {
        height: 15.13rem;
      }

      .buttonItem {
        width: 13.75rem;
        height: 9.25rem;
        img {
          width: 100%;
          height: 100%;
        }

        &.Pc {
          width: 22.5rem;
          height: 15.13rem;
        }
      }
    }
  }
}

.back {
  width: 2.375rem;
  height: 3.625rem;
  position: absolute;
  top: 1.5rem;
  left: 3.75rem;
  cursor: pointer;

  img {
    width: 2.375rem;
    height: 1.875rem;
  }
  .backTitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 1.125rem;
    color: #252525;
    letter-spacing: 0;
    font-weight: 400;
    &:hover {
      color: #ff000d;
    }
  }
}
</style>
